// @ts-strict-ignore
import React from 'react'
import { Tile } from '../../atoms'
import sw from '@u/switch'
import { ButtonLink } from '@uswitch/ev-components/lib/components/elements/button-link'
import { gtmTrack } from '@u/tracking'
import { timeout, useComponentTracking } from '@uswitch/ev-utils/component-events'

const ButtonWrapper = (props) => {
  const { buttonVariant = 'default', children, href } = props
  const trackComponent = useComponentTracking()

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    gtmTrack('GA Button Clicked', 'Functional Interaction', `${children}`)
    timeout(
      trackComponent('Dynamic Component Event', 'CTAButtonClicked', { text: `${children}` }),
    ).then(() => {
      if (props.target) {
        window.open(href)
      } else {
        window.location.href = href
      }
    })
  }

  return sw({
    tile: (
      <Tile {...props} onClick={(e: React.MouseEvent) => onClick(e)}>
        {children}
      </Tile>
    ),
    default: (
      <ButtonLink {...props} onClick={(e: React.MouseEvent) => onClick(e)}>
        {children}
      </ButtonLink>
    ),
  })(buttonVariant)
}

export default ButtonWrapper
